import { render, staticRenderFns } from "./Informationcheck.vue?vue&type=template&id=5dc104a2&scoped=true"
import script from "./Informationcheck.vue?vue&type=script&lang=js"
export * from "./Informationcheck.vue?vue&type=script&lang=js"
import style0 from "./Informationcheck.vue?vue&type=style&index=0&id=5dc104a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc104a2",
  null
  
)

export default component.exports